<template lang="pug">
  div
    v-checkbox.ml-2(
      v-model="selectedAll"
      :color="checkboxColor"
      :indeterminate="ideterminate()"
      :value="!!inputValue.length && selectedAll"
      @change="onSelectedAll"
      :disabled="loading"
      label="Выбрать всех"
    )
    v-virtual-scroll.grey.lighten-5(
      :items="items"
      item-height="64"
      height="400"
    )
      template(v-slot:default="{ item }")
          v-list-item(
            :key="item.id"
            :disabled="loading"
          )
            v-list-item-action
              v-checkbox(
                v-model="inputValue"
                :color="checkboxColor"
                multiple
                :value="item"
              )
                template(#label)
                  slot(name="label" :item="item")
                    p.mt-4.ml-4.
                      {{item.first_name}} {{item.middle_name}} {{item.last_name}}
</template>
<script>

export default {
  name: 'VirtualSelect',
  props: {
    value: { type: Array, default: () => [] },
    items: { type: Array, required: true },
    loading: { type: Boolean, default: false },
    checkboxColor: { type: String, default: 'primary' },
  },
  data() {
    return {
      selectedAll: false,
      search: '',
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        return this.$emit('input', value);
      },
    },
  },
  methods: {
    ideterminate() {
      return (this.inputValue.length > 0
        && this.inputValue.length < this.items.length)
        && this.selectedAll;
    },
    onSelectedAll(value) {
      if (value) this.inputValue = this.items;
      else this.inputValue = [];
    },
  },
};
</script>
